import React, { useEffect, useState } from 'react'
import { Text, StyleSheet, View, Platform, Pressable, useWindowDimensions, Image } from 'react-native'
import LinearGradient from 'react-native-linear-gradient';
import { useTheme } from '@react-navigation/native';
import Ionicons from "@react-native-vector-icons/ionicons/static";
import Arrows from '../../img/arrows';


const CustomButton = ({ onPress, text, type = "PRIMARY", bgColor, fgColor, show = "HIDE",
  iconName = undefined, svgName = undefined, sz = 18, disabled = false, badgeValue = 0, textTop = 1,
  pagination = false, imageBeforeText, iconNameAfterText, tooltipText = "", isGradient = false }) => {

  const { colors } = useTheme();
  const { width, height } = useWindowDimensions();
  const isWeb = Platform.OS === 'web';
  const isWideScreen = isWeb && width > 992;
  const isExtraWideScreen = isWeb && width > 1300;
  const styles = makeStyles(colors, width, height, pagination, isWeb, isWideScreen, isExtraWideScreen, disabled);
  const [showTooltip, setShowTooltip] = useState(false);
  const buttonStyle = [
    styles.container,
    styles[`container_${type}`],
    bgColor ? { backgroundColor: bgColor } : {}
  ];

  return (
    <View style={styles.viewContainer}>
      <Pressable
        onPress={onPress}
        disabled={disabled}
        // * To show tooltip on mouse hover - This will work only on web but it will not break mobile
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        style={buttonStyle}
      >
        {isGradient && (
          <LinearGradient
            pointerEvents="none"
            colors={[colors.green_dark, colors.green]}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 0 }}
            style={[
              StyleSheet.absoluteFill,
              { borderRadius: StyleSheet.flatten(buttonStyle).borderRadius }
            ]}
          />
        )}

          {textTop == 1 && <Text
            style={[
              styles.text,
              styles[`text_${type}`],
              // The below will override any colour coming from the styles below. 
              fgColor ? { color: fgColor } : {}
            ]}>
            {text}
          </Text>
          }
          {badgeValue > 0 && <View
            style={[
              styles.circle,
              styles[`circle_${type}`],
              fgColor ? { color: fgColor } : {}
            ]} >
            <Text
              style={[
                styles.text,
                { color: 'white' },
                fgColor ? { color: fgColor } : {}
              ]}>
              {badgeValue}
            </Text>
          </View>}

          {!svgName
            ?
            iconName && <Ionicons
              name={iconName}
              size={sz}
              style={[
                styles[`icon_${show}`],
              ]} >
            </Ionicons>
            :
            svgName === 'arrows'
              ?
              <Arrows />
              :
              <></>
          }

          {imageBeforeText &&
            <Image
              style={[
                styles[`image`],
                styles[`icon_${show}`],
              ]}
              source={{ uri: `data:image/png;base64,${imageBeforeText}` }}
            />
          }

          {textTop == 0 && <Text
            style={[
              styles.text,
              styles[`text_${type}`],
              // The below will override any colour coming from the styles below. 
              fgColor ? { color: fgColor } : {}
            ]}>
            {text}
          </Text>
          }

          {iconNameAfterText &&
            <View style={[
              styles.icon_after_text_container,
              styles[`icon_after_text_${type}`],
            ]}>
              <View style={styles.verticalLineSeparator} />
              <Ionicons
                name={iconNameAfterText}
                size={sz}
                style={[
                  styles[`icon_${type}`],
                ]}>
              </Ionicons>
            </View>
          }
      </Pressable>
      {
        showTooltip && tooltipText !== "" && (
          <View style={styles.tooltip}>
            <Text style={styles.tooltipText}>{tooltipText}</Text>
          </View>
        )
      }
    </View >
  )
};



const makeStyles = (colors, width, height, pagination, isWeb, isWideScreen, isExtraWideScreen, disabled) => StyleSheet.create({
  viewContainer: {
    position: 'relative',
    alignItems: 'center', // horizontal centring
    justifyContent: 'center', // vertical centring if needed
    overflow: 'visible',
    flexDirection: 'column', // default but explicit 
  },
  tooltip: {
    position: 'absolute',
    top: '100%',
    backgroundColor: '#333',
    padding: 10,
    borderRadius: 8,
    maxWidth: 250,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.8,
    shadowRadius: 4,
    elevation: 5,
    zIndex: 10200,
  },
  tooltipText: {
    color: '#fff',
    fontSize: 14,
  },

  container: {
    padding: '3%',
    flexDirection: 'row',
    borderRadius: 5,
    backgroundColor: colors.buttons,
    justifyContent: 'center',
    paddingHorizontal: 12,
    alignSelf: 'center',
    alignItems: 'center',
    borderRadius: 20,
  },

  text: {
    fontWeight: 'bold',
    alignSelf: 'center',
    color: colors.text_primary,
    fontFamily: 'Roboto-Medium',
    fontSize: 16,
  },

  row: {
    flex: 1,
    flexDirection: "row"
  },
  circle: {
    width: 27,
    height: 27,
    marginRight: '5%',
    borderRadius: 20,
    justifyContent: 'center',
    backgroundColor: '#f63737',
  },

  container_LOGIN: {
    backgroundColor: colors.background_approved,
    fontWeight: 'bold',
    paddingVertical: width < 600 ? 18 : 12,
    paddingHorizontal: width < 600 ? 0 : 32,
    minWidth: 120,
    minHeight: width < 600 ? 50 : 44,
    justifyContent: 'center',
    alignItems: 'center',
    margin: 10,

  },

  container_SHOW_REPORT: {
    justifyContent: 'flex-end',     // Align to the right (for top-right button)
    paddingVertical: 8,
    backgroundColor: colors.background_approved,
    marginTop: 10,
    marginStart: 10,              // Provide space above button from variable view
    alignSelf: 'flex-start',
  },

  text_SHOW_REPORT: {
    fontSize: 14,
    fontWeight: '600',
    color: colors.text_primary,
    marginLeft: 6,
  },

  icon_SHOW_REPORT: {
    marginHorizontal: 5,
    color: colors.text_primary,
  },

  container_PRIMARY: {
    backgroundColor: colors.buttons_primary,
    borderRadius: 20,
    width: '75%',
    paddingTop: '5%',
    alignItems: 'center',
    paddingBottom: '5%',
    marginTop: '5%',
  },

  container_SECONDARY: {
    borderColor: colors.buttons_secondary,
    borderWidth: 2,
    paddingTop: '5%',
    paddingBottom: '5%',
  },

  container_ACCOUNT: {
    borderColor: colors.buttons_secondary,
    borderWidth: 0,
    margin: '3%',
    flexDirection: 'row',
  },

  container_LAA: {
    borderColor: colors.buttons,
    borderWidth: 0,
    margin: '3%',
    flexDirection: 'row',
  },

  text_LAA: {
    fontSize: 18,
    flex: 1,
    fontWeight: 'bold',
    alignSelf: 'center',
    color: colors.text_primary,
  },

  container_SETTINGS: {
    borderColor: colors.buttons,
    borderWidth: 0,
    margin: '3%',
    flexDirection: 'row',
  },

  text_SETTINGS: {
    fontSize: 18,
    flex: 1,
    marginLeft: '5%',
    fontWeight: 'bold',
    color: colors.text_primary,
  },

  container_SAVE: {
    alignSelf: 'flex-end',
    margin: '3%',
    backgroundColor: colors.buttons_primary,
    borderWidth: 1,
  },

  text_SAVE: {
    fontSize: 16,
    alignSelf: 'center',
  },

  // Monthly Leave Scheduler for Team 
  container_MONTHLYLEAVESCHEDULE: {
    alignSelf: 'center',
    width: 40,
    height: 40,
    borderRadius: 0,
  },

  text_MONTHLYLEAVESCHEDULE: {
    // No Text in Home BELL
  },

  icon_MONTHLYLEAVESCHEDULE: {
    color: colors.background_inverted,
  },

  // * Edit Button 
  container_EDITBUTTON: {
    borderRadius: 100,
    paddingVertical: 10,
    paddingHorizontal: 15,
    alignItems: 'center',
    justifyContent: 'center',
    shadowColor: 'rgba(92, 143, 26, 0.4)',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.35,
    shadowRadius: 8,
    elevation: 3,
  },

  text_EDITBUTTON: {
    color: '#FFFFFF',
    fontSize: 14,
    fontWeight: '700',
    letterSpacing: 0.5,
  },

  // Modal 
  container_BORDERLESS: {
    width: (Platform.OS === 'web' && width > 1300) ? width / 7 : width / 2,
    backgroundColor: colors.background_gray,
    alignItems: 'center',
    marginTop: '12%',
    marginLeft: '8%',
    marginRight: '8%',
    width: '35%',
    height: 45,
    borderRadius: 60,
    borderWidth: 1,
    justifyContent: 'center',
  },

  text_BORDERLESS: {
    color: colors.text_primary,
  },

  icon_BORDERLESS: {
    color: colors.text_primary,
    alignContent: 'center',
  },

  container_BORDERLESS_FIXEDWIDTH: {
    width: 50,
    backgroundColor: 'transparent',
    alignItems: 'center',
  },

  text_BORDERLESS_FIXEDWIDTH: {
  },

  icon_BORDERLESS_FIXEDWIDTH: {
    color: colors.text_primary,
    alignContent: 'center',
  },

  container_BORDERLESS_MODAL: {
    width: (Platform.OS === 'web' && width > 1300) ? width / 6 : '95%',
    backgroundColor: colors.background_gray,
    borderColor: colors.background_inverted,
    justifyContent: 'center',
    alignContent: 'center',
    margin: 5,
    borderWidth: 0,
  },

  text_BORDERLESS_MODAL: {
    fontWeight: 'normal',
    fontSize: 12,
    textAlign: 'center',
    opacity: 0.7,
    color: colors.text_primary
  },

  container_BORDERLESS_MODAL_SELECTED: {
    width: (Platform.OS === 'web' && width > 1300) ? width / 6 : '95%',
    backgroundColor: 'white',
    justifyContent: 'center',
    borderColor: colors.background_inverted,
    margin: 5,
    alignContent: 'center',
    borderWidth: 0,
  },

  text_BORDERLESS_MODAL_SELECTED: {
    fontWeight: 'bold',
    fontSize: 15,
    textAlign: 'center',
    color: colors.buttons_primary
  },

  container_HOME: {
    backgroundColor: colors.text_white,
    width: isWideScreen ? (pagination ? width / 9 : width / 6) : width * 0.45,
    margin: 8,
    borderRadius: 20,
    borderWidth: 1,
    flexDirection: isWeb ? 'row' : 'column',
    paddingVertical: 8,
    paddingHorizontal: 14,
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    shadowColor: 'rgba(92, 143, 26, 0.4)',
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 0.35,
    shadowRadius: 8,
    elevation: 5,
    transition: 'background-color 0.3s ease',
  },
  text_HOME: {
    textAlign: 'center',
    paddingHorizontal: 10,
    flexWrap: isExtraWideScreen ? 'nowrap' : 'wrap',
    fontSize: isExtraWideScreen ? 14 : 10,
    color: colors.text_primary,
    fontWeight: '500',
  },
  icon_HOME: {
    alignSelf: 'center',
    marginBottom: isWeb ? 0 : 6,
    marginRight: isWeb ? 8 : 0,
    fontSize: isWideScreen ? 24 : 18,
    color: colors.text_secondary,
  },
  container_HOME_SELECTED: {
    backgroundColor: colors.buttons_primary,
    borderColor: colors.buttons_primary,
    width: isWideScreen ? (pagination ? width / 9 : width / 6) : width * 0.45,
    margin: 8,
    borderRadius: 20,
    borderWidth: 1,
    flexDirection: isWeb ? 'row' : 'column',
    paddingVertical: 8,
    paddingHorizontal: 14,
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    shadowColor: 'rgba(92, 143, 26, 0.4)',
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 0.35,
    shadowRadius: 8,
    elevation: 5,
    transition: 'background-color 0.3s ease',
  },
  text_HOME_SELECTED: {
    textAlign: 'center',
    paddingHorizontal: 12,
    flexWrap: isExtraWideScreen ? 'nowrap' : 'wrap',
    fontSize: isExtraWideScreen ? 16 : 12,
    color: colors.text_white,
    fontWeight: '600',
  },
  icon_HOME_SELECTED: {
    alignSelf: 'center',
    marginBottom: isWeb ? 0 : 6,
    marginRight: isWeb ? 8 : 0,
    fontSize: isWideScreen ? 26 : 20,
    color: colors.text_primary,
  },
  container_REM: {
    backgroundColor: colors.buttons,
    // width: (Platform.OS === 'web' && width > 992) ? (pagination) ? width / 9 : width / 6 : width * 0.30,
    margin: 0,
    borderRadius: 20,
    flexDirection: 'row',
    paddingTop: 0,
    paddingBottom: 0,
    alignSelf: 'center',
    alignItems: 'center',
    verticalAlign: 'middle',
    justifyContent: 'center',
  },

  text_REM: {
    textAlign: 'center',
    flexWrap: (Platform.OS === 'web' && width > 1300) ? 'nowrap' : 'wrap',
    verticalAlign: 'middle',
    fontSize: (Platform.OS === 'web' && width > 1300) ? 14 : 12,
    color: colors.text_primary,
  },

  icon_REM: {
    alignSelf: 'center',
    verticalAlign: 'middle',
    color: colors.text_primary,
  },



  container_HOME_SMALL: {
    backgroundColor: colors.buttons_primary,
    width: 50,
    height: 50,
    padding: 10,
    margin: '2%',
    paddingTop: '2%',
    paddingBottom: '0%',

    alignSelf: 'center',
  },

  text_HOME_SMALL: {
    // No Text in Home Small
  },

  icon_HOME_SMALL: {
    alignItems: 'center',
    color: colors.text_primary,
  },

  container_HOME_BELL: {
    backgroundColor: 'transparent',
    marginRight: '10%',
    alignSelf: 'flex-end',
  },

  text_HOME_BELL: {
    // No Text in Home BELL
  },

  icon_HOME_BELL: {
    color: colors.text_primary,
    alignItems: 'center',
  },

  container_PART: {
    paddingRight: 5,
    paddingLeft: 5,
    paddingTop: 5,
    paddingBottom: 5,
    alignSelf: 'center',
  },

  text_PART: {
    // No Text in Home BELL
  },

  icon_PART: {
    color: colors.text_primary,
    alignItems: 'center',
  },

  container_TIMESHEET: {
    paddingRight: 0,
    paddingLeft: 0,
    paddingTop: 0,
    paddingBottom: 0,
    marginHorizontal: 5,
    marginRight: '0',
    alignSelf: 'center',
  },

  text_TIMESHEET: {
    // No Text in Home BELL
  },

  icon_TIMEHSEET: {
    color: colors.text_primary,
    alignItems: 'center',
  },


  container_FLATLISTHEADER: {
    backgroundColor: 'transparent',
    alignContent: 'flex-end'
  },

  icon_FLATLISTHEADER: {
    color: colors.text_primary,
    alignItems: 'center',
  },

  container_CALENDAR: {
    backgroundColor: 'transparent',
    borderWidth: 0,
    paddingRight: 0,
    paddingLeft: 0,
    paddingTop: 0,
    paddingBottom: 0,
    marginRight: Platform.OS === 'web' ? 10 : 5,
    alignSelf: 'flex-end',
  },

  text_CALENDAR: {
    color: colors.text_secondary,
    fontWeight: 'bold',
  },

  container_NEXT_PAGE: {
    backgroundColor: 'transparent',
    paddingRight: 0,
    paddingLeft: 0,
    paddingTop: 0,
    paddingBottom: 0,
    // alignSelf: 'flex-end',
  },

  text_NEXT_PAGE: {
    // No Text in Home BELL
  },

  icon_NEXT_PAGE: {
    color: colors.text_primary,
    alignItems: 'center',
  },

  container_HOME_LANGUAGE: {
    marginLeft: '10%',
  },

  text_HOME_LANGUAGE: {
    // No Text in Home LANGUAGE
  },

  icon_HOME_LANGUAGE: {
    color: colors.text_primary,
  },

  container_APPROVE: {
    width: Platform.OS === 'web' ? 200 : 150,
    paddingHorizontal: 12,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.background_approved,
    borderColor: colors.background_approved,
  },

  text_APPROVE: {
    alignSelf: 'center',
    color: colors.text_white
  },

  container_COMPLETE: {
    width: Platform.OS === 'web' ? 200 : 150,
    paddingHorizontal: 12,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.background_approved,
    borderColor: colors.background_approved,
  },

  text_COMPLETE: {
    alignSelf: 'center',
    color: colors.text_approved,
    fontSize: Platform.OS === 'web' ? 16 : 12
  },

  container_CLOSED: {
    width: Platform.OS === 'web' ? 200 : 150,
    paddingHorizontal: 12,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: "lightcoral",
    borderColor: "lightcoral",
  },

  text_CLOSED: {
    alignSelf: 'center',
    color: colors.text_rejected,
    fontSize: Platform.OS === 'web' ? 16 : 12
  },

  container_PENDING: {
    width: Platform.OS === 'web' ? 200 : 150,
    backgroundColor: "khaki",
    borderColor: "khaki",
    paddingHorizontal: 12,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },

  text_PENDING: {
    alignSelf: 'center',
    color: colors.text_approved,
    fontSize: Platform.OS === 'web' ? 16 : 12
  },

  container_WAITING: {
    width: Platform.OS === 'web' ? 200 : 150,
    backgroundColor: "white",
    borderColor: "khaki",
    borderWidth: 2,
    paddingHorizontal: 12,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },

  text_WAITING: {
    alignSelf: 'center',
    color: colors.text_rejected,
    fontSize: Platform.OS === 'web' ? 16 : 12
  },
  container_REJECT: {
    width: Platform.OS === 'web' ? 200 : 150,
    paddingHorizontal: 12,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.background_rejected,
    borderColor: colors.background_rejected,
  },

  text_REJECT: {
    alignSelf: 'center',
    color: colors.text_rejected
  },

  container_REJECTLAA: {
    marginHorizontal: 5,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.background_rejected,
    borderColor: colors.background_rejected,
  },

  text_REJECTLAA: {
    alignSelf: 'center',
    color: colors.text_rejected
  },

  icon_REJECTLAA: {
    color: colors.text_primary,
    alignItems: 'center',
  },

  container_APPROVELAA: {
    marginHorizontal: 5,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.background_approved,
    borderColor: colors.background_approved,
  },

  text_APPROVELAA: {
    alignSelf: 'center',
    color: colors.text_approved
  },

  icon_APPROVELAA: {
    color: colors.text_primary,
    alignItems: 'center',
  },

  container_SHOWHIDE: {
    flex: 1,
    flexDirection: 'row',
    alignSelf: 'flex-start',
    backgroundColor: 'transparent',
    paddingTop: '2%',
    paddingBottom: '2%'
  },

  text_SHOWHIDE: {
    fontSize: 16,
    alignSelf: 'center',
  },

  icon_SHOWHIDE: {
    margin: '3%',
    color: colors.text_primary,
  },

  container_SURVEY: {
    width: Platform.OS === 'web' && width > 1300 ? width * 0.10 : width * 0.2,
    flexDirection: 'row',
    margin: 10,
    marginHorizontal: 35,
    alignSelf: 'flex-start',
    backgroundColor: colors.background_approved,
  },

  text_SURVEY: {
    fontSize: 14,
    marginRight: '10%',
    alignSelf: 'center',
  },

  icon_SURVEY: {
    marginLeft: '10%',
    color: colors.text_primary,
  },

  container_IMPORT: {
    width: Platform.OS === 'web' && width > 1300 ? width * 0.10 : width * 0.2,
    flexDirection: 'row',
    margin: 0,
    alignSelf: 'flex-start',
    backgroundColor: colors.background_approved,
  },

  text_IMPORT: {
    fontSize: 14,
    marginRight: '10%',
    alignSelf: 'center',
  },

  icon_IMPORT: {
    marginLeft: '10%',
    color: colors.text_primary,
  },

  container_COMPANY_SAVE: {
    width: Platform.OS === 'web' && width > 1300 ? width * 0.10 : width * 0.05,
    flexDirection: 'row',
    margin: 10,
    alignSelf: 'flex-start',
    backgroundColor: colors.background_approved,
  },

  text_COMPANY_SAVE: {
    fontSize: 14,
    marginRight: '10%',
    alignSelf: 'center',
  },

  icon_COMPANY_SAVE: {
    marginHorizontal: 5,
    color: colors.text_primary,
  },

  container_BUTTON_SAVE: {
    backgroundColor: colors.background_approved,
    fontWeight: 'bold',
    paddingVertical: width < 600 ? 18 : 12,
    shadowColor: 'rgba(92,143,26,0.35)',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.8,
    shadowRadius: 4,
    paddingHorizontal: width < 600 ? 0 : 32,
    minWidth: width < 600 ? width * 0.8 : 120,
    minHeight: width < 600 ? 50 : 44,
    justifyContent: 'center',
    alignItems: 'center',
    margin: 10,
  },

  text_BUTTON_SAVE: {
    fontSize: 14,
    fontWeight: '700',
    textAlign: 'center',
    color: colors.text_white
  },

  icon_BUTTON_SAVE: {
    marginHorizontal: 5,
    color: colors.text_primary,
  },

  container_BUTTON_ADD: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    paddingVertical: 11,
    paddingHorizontal: 22,
    borderRadius: 100,
    borderWidth: 1.5,
    borderColor: colors.border_card,
    backgroundColor: disabled ? colors.background_disabled : colors.background_white,
    shadowColor: 'rgba(92, 143, 26, 1)',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.06,
    shadowRadius: 6,
    elevation: 2,
    minWidth: width < 600 ? width * 0.8 : 120,
    minHeight: width < 600 ? 50 : 44,
  },

  text_BUTTON_ADD: {
    fontSize: 14,
    fontWeight: '700',
    textAlign: 'center',
    color: colors.text_secondary
  },

  icon_BUTTON_ADD: {
    marginHorizontal: 5,
    color: colors.text_secondary,
  },

  container_COMPANY_BRANCHES_DELETE: {
    width: Platform.OS === 'web' && width > 992 ? width * 0.10 : width * 0.05,
    height: Platform.OS === 'web' && width > 992 ? '35%' : '100%',
    flexDirection: 'row',
    margin: 10,
    alignSelf: 'flex-end',
    backgroundColor: colors.background_rejected,
    justifyContent: 'center'
  },

  text_COMPANY_BRANCHES_DELETE: {
    fontSize: 14,
    marginRight: '10%',
    alignSelf: 'center',
    textAlign: 'center'
  },

  container_BUTTON_CANCEL: {
    backgroundColor: colors.background_rejected,
    fontWeight: 'bold',
    paddingVertical: width < 600 ? 18 : 12,
    paddingHorizontal: width < 600 ? 0 : 32,
    minWidth: width < 600 ? width * 0.8 : 120,
    minHeight: width < 600 ? 50 : 44,
    justifyContent: 'center',
    alignItems: 'center',
    margin: 10,
  },


  text_BUTTON_CANCEL: {
    fontSize: 14,
    alignSelf: 'center',
    textAlign: 'center'
  },

  container_BUTTON_TABMENU: {
    paddingVertical: 3,
    paddingHorizontal: Math.min(Math.max(width * 0.01, 5), 16),
    marginRight: Math.min(Math.max(width * 0.01, 3), 8),
    borderRadius: 5,
    backgroundColor: colors.background_card,
    justifyContent: 'center',
    alignItems: 'center',
    elevation: 5,
    shadowColor: colors.card_line,
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0.3,
    shadowRadius: 5,
  },


  text_BUTTON_TABMENU: {
    fontSize: 14,
    fontWeight: '100',
    textAlign: 'center',
  },

  container_BUTTON_TABMENUSELECTED: {
    margin: Math.min(Math.max(width * 0.01, 5), 10),
    borderRadius: 5,
    borderWidth: 2,
    elevation: 5,
    shadowColor: colors.card_line,
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0.3,
    shadowRadius: 5,
    backgroundColor: colors.background_card,
    borderColor: colors.buttons_submit,
  },


  text_BUTTON_TABMENUSELECTED: {
    fontSize: 14,
    fontWeight: '100',
    textAlign: 'center',
  },

  container_LEAVE_ANALYSIS_TOGGLE: {
    width: Platform.OS === 'web' && width > 992 ? width * 0.20 : width * 0.10,
    flexDirection: 'row',
  },

  container_LEAVE_ANALYSIS_CREATE_NEW: {
    width: Platform.OS === 'web' && width > 1200 ? width * 0.10 : width * 0.05,
    height: Platform.OS === 'web' && width > 1200 ? width * 0.03 : '100%',
    flexDirection: 'row',
    margin: 10,
    // alignSelf: 'flex-end',
    backgroundColor: colors.buttons_primary,
    justifyContent: 'center'
  },

  text_LEAVE_ANALYSIS_CREATE_NEW: {
    fontSize: 14,
    alignSelf: 'center',
    textAlign: 'center'
  },

  container_ASSM: {
    width: Platform.OS === 'web' && width > 1300 ? width * 0.10 : width * 0.05,
    // flexDirection: 'row',
    margin: 10,
    flex: 1,
    alignSelf: 'flex-start',
    backgroundColor: colors.background_approved,
  },

  text_ASSM: {
    fontSize: 14,
    marginRight: '10%',
    alignSelf: 'center',
  },

  icon_ASSM: {
    marginLeft: '10%',
    color: colors.text_primary,
  },
  container_SURVEYREJECT: {
    width: Platform.OS === 'web' && width > 1300 ? width * 0.10 : width * 0.2,
    flexDirection: 'row',
    margin: 10,
    alignSelf: 'flex-start',
    backgroundColor: colors.background_rejected,
  },

  text_SURVEYREJECT: {
    fontSize: 14,
    marginRight: '10%',
    alignSelf: 'center',
  },

  icon_SURVEYREJECT: {
    marginLeft: '10%',
    color: colors.text_primary,
  },

  container_TOPRIGHT: {
    paddingRight: Platform.OS === 'web' && width > 1300 ? '5%' : '3%',
    paddingLeft: Platform.OS === 'web' && width > 1300 ? '5%' : '3%',
    paddingTop: Platform.OS === 'web' && width > 1300 ? '1%' : '3%',
    paddingBottom: Platform.OS === 'web' && width > 1300 ? '0%' : '3%',
    alignSelf: 'flex-end',
    justifyContent: 'flex-start',
    marginRight: '3%',
    backgroundColor: 'transparent',
    borderWidth: 0,
    flex: 1
  },

  text_TOPRIGHT: {
    fontSize: 16,
    color: colors.buttons_primary,
    alignSelf: 'center',
  },

  container_TOPRIGHT_EXTRA_MARGIN: {
    alignSelf: 'flex-end',
    marginRight: '10%',
    backgroundColor: 'transparent',
    borderWidth: 0,
  },

  text_TOPRIGHT_EXTRA_MARGIN: {
    fontSize: 16,
    color: colors.buttons_primary,
    alignSelf: 'center',
  },

  container_SUBMIT_DISABLED: {
    fontWeight: 'bold',
    paddingVertical: width < 600 ? 18 : 12,
    paddingHorizontal: width < 600 ? 0 : 32,
    minWidth: width < 600 ? width * 0.8 : 120,
    minHeight: width < 600 ? 50 : 44,
    justifyContent: 'center',
    alignItems: 'center',
    margin: 10,
    alignSelf: 'flex-end',
    backgroundColor: colors.buttons_primary,
    borderWidth: 1,
  },

  text_SUBMIT_DISABLED: {
    fontSize: 16,
    alignSelf: 'center',
    color: colors.text_white
  },

  container_SUBMIT_DISABLED_EXTRA_MARGIN: {
    alignSelf: 'flex-end',
    margin: '10%',
    backgroundColor: colors.buttons_primary,
    borderWidth: 1,
    backgroundColor: '#a1a1a1',
  },

  text_SUBMIT_DISABLED_EXTRA_MARGIN: {
    fontSize: 16,
    alignSelf: 'center',
  },

  icon_HIDE: {
    opacity: 0,
    height: 0,
    width: 0
  },

  icon_SHOW: {
    color: colors.text_primary,
    marginTop: '1%'
  },

  icon_SETTINGS: {
    color: colors.text_primary,
    marginTop: '1%',
    marginRight: '5%'
  },

  text_TERTIARY: {
    fontWeight: 'bold',
    color: 'gray',
  },

  text_ACCOUNT: {
    fontSize: 18,
    flex: 1,
    fontWeight: 'bold',
    color: colors.text_primary,
  },

  text_SECONDARY: {
    color: 'blue',
  },

  container_SAVE_CALENDAR_DATES: {
    marginTop: '3%',
    width: 'auto',
    height: 'auto',
    backgroundColor: 'transparent',
    borderRadius: 17,
    borderColor: 'transparent',
    justifyContent: 'center',
    alignItems: 'center',
    paddingRight: '2%',
    paddingLeft: '2%',
    paddingTop: 0,
    paddingBottom: '2%',
  },

  text_SAVE_CALENDAR_DATES: {
    fontWeight: '100',
    color: colors.text_secondary,
  },

  container_SAVE_CALENDAR_DATES_WEB: {
    backgroundColor: 'transparent',
    width: Platform.OS === 'web' ? 200 : 150,
    paddingTop: 5,
    paddingHorizontal: 12,
    margin: 5,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },

  text_SAVE_CALENDAR_DATES_WEB: {
    fontWeight: '100',
    color: colors.text_secondary,
  },

  container_CONTENTS_SECTION: {
    backgroundColor: 'transparent',
    alignSelf: 'flex-start',
    justifyContent: 'center',
    padding: 0,
    marginTop: 20,
  },

  text_CONTENTS_SECTION: {
    fontSize: 18,
    fontWeight: 'bold',
    color: colors.text_secondary,
  },

  container_CONTENTS: {
    flex: 1,
    backgroundColor: 'transparent',
    alignSelf: 'flex-start',
    justifyContent: 'center',
    padding: 0,
    marginBottom: 20,
    marginStart: 3,
  },

  text_CONTENTS: {
    textAlign: 'left',
    fontSize: 14,
    color: colors.text_muted,
  },


  container_STATUS: {
    marginTop: '2%',
    width: 'auto',
    height: 'auto',
    backgroundColor: 'transparent',
    borderRadius: 17,
    borderColor: 'transparent',
    justifyContent: 'center',
    alignItems: 'center',
    paddingRight: '2%',
    paddingLeft: '2%',
    paddingTop: '2%',
    paddingBottom: '2%',
  },

  text_STATUS: {
    fontWeight: '100',
    color: colors.text_secondary,
    textDecorationLine: 'underline',
  },

  container_SUBMIT_MIDDLE_DISABLED: {
    alignSelf: 'center',
    margin: 0,
    padding: 0,
    backgroundColor: colors.buttons_primary_disabled,
    borderRadius: 17,
    borderColor: 'transparent',
  },

  text_SUBMIT_MIDDLE_DISABLED: {
    color: colors.text_primary,
    fontWeight: 'normal',
  },

  container_SUBMIT_MIDDLE: {
    alignSelf: 'center',
    padding: 5,
    width: Platform.OS === 'web' ? 200 : 150,
    backgroundColor: colors.buttons_primary,
    borderRadius: 17,
    borderColor: 'transparent',
  },

  text_SUBMIT_MIDDLE: {
    color: colors.text_primary,
    fontWeight: 'normal',
  },

  container_SUBMIT_WEB_DISABLED: {
    backgroundColor: colors.buttons_primary_disabled,
    fontWeight: 'bold',
    paddingVertical: width < 600 ? 18 : 12,
    paddingHorizontal: width < 600 ? 0 : 32,
    minWidth: width < 600 ? width * 0.8 : 120,
    minHeight: width < 600 ? 50 : 44,
    alignSelf: 'flex-end',
    margin: 10,
  },

  text_SUBMIT_WEB_DISABLED: {
    color: colors.text_white,
    fontWeight: 'normal',
  },

  container_SUBMIT_WEB: {
    backgroundColor: colors.buttons_primary,
    fontWeight: 'bold',
    paddingVertical: width < 600 ? 18 : 12,
    paddingHorizontal: width < 600 ? 0 : 32,
    minWidth: width < 600 ? width * 0.8 : 120,
    minHeight: width < 600 ? 50 : 44,
    alignSelf: 'flex-end',
    margin: 10,
  },

  text_SUBMIT_WEB: {
    color: colors.text_white,
    fontWeight: 'normal',
  },

  container_SAVE_WEB_DISABLED: {
    backgroundColor: colors.background_not_submitted,
    fontWeight: 'bold',
    paddingVertical: width < 600 ? 18 : 12,
    shadowColor: 'rgba(92,143,26,0.35)',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.8,
    shadowRadius: 4,
    paddingHorizontal: width < 600 ? 0 : 32,
    minWidth: width < 600 ? width * 0.8 : 120,
    minHeight: width < 600 ? 50 : 44,
    justifyContent: 'center',
    alignItems: 'center',
    margin: 10,
  },

  text_SAVE_WEB_DISABLED: {
    fontSize: 14,
    fontWeight: '700',
    textAlign: 'center',
    color: colors.text_white
  },

  container_SAVE_WEB: {
    margin: 15,
    padding: 5,
    width: Platform.OS === 'web' ? 200 : 150,
    backgroundColor: colors.buttons_primary,
    borderRadius: 17,
    borderColor: 'transparent',
    alignSelf: 'flex-end',
  },

  text_SAVE_WEB: {
    color: colors.text_primary,
    fontWeight: 'normal',
  },

  //* Back to LAA from team schedule
  container_BACK_TO_LAA: {
    marginTop: '5%',
    margin: '3%',
    width: 'auto',
    height: 40,
    backgroundColor: colors.buttons_primary,
    borderRadius: 17,
    borderColor: 'transparent',
    paddingRight: '2%',
    paddingLeft: '1%',
    paddingTop: '1%',
    paddingBottom: '1%',
    alignSelf: 'flex-start',
    flexDirection: 'row',
    alignItems: 'center',
  },

  text_BACK_TO_LAA: {
    color: colors.text_primary,
    fontWeight: 'normal',
  },

  icon_BACK_TO_LAA: {
    color: colors.text_primary,
  },

  container_NEW_DOCUMENT: {
    width: Platform.OS === 'web' && width > 1300 ? width * 0.01 : width * 0.05,
    flexDirection: 'row',
    margin: 10,
    alignSelf: 'flex-end',
    // backgroundColor: colors.background_approved,
  },

  text_NEW_DOCUMENT: {
    fontSize: 14,
    marginRight: '10%',
    alignSelf: 'center',
  },

  icon_NEW_DOCUMENT: {
    marginLeft: '10%',
    color: colors.text_primary,
  },

  container_SUBMIT_MODAL: {
    width: Platform.OS === 'web' && width > 992 ? width * 0.10 : width * 0.05,
    height: Platform.OS === 'web' && width > 992 ? '35%' : '100%',
    flexDirection: 'row',
    margin: 10,
    alignSelf: 'flex-end',
    backgroundColor: colors.background_approved,
    justifyContent: 'center'
  },

  text_SUBMIT_MODAL: {
    fontSize: 14,
    marginRight: '10%',
    alignSelf: 'center',
  },

  image: {
    width: 30,
    height: 30,
    borderRadius: 100,
    borderWidth: 1,
    marginRight: 2,
  },

  container_SELECT_EMPLOYEE_FIND: {
    backgroundColor: colors.background_approved,
    fontWeight: 'bold',
    paddingVertical: width < 600 ? 18 : 12,
    paddingHorizontal: width < 600 ? 0 : 32,
    minWidth: width < 600 ? width * 0.8 : 120,
    minHeight: width < 600 ? 50 : 44,
    justifyContent: 'center',
    alignItems: 'center',
  },

  text_SELECT_EMPLOYEE_FIND: {
    fontSize: 16,
    alignSelf: 'center',
  },

  container_SELECT_EMPLOYEE_RESET: {
    backgroundColor: colors.background_rejected,
    fontWeight: 'bold',
    paddingVertical: width < 600 ? 18 : 12,
    paddingHorizontal: width < 600 ? 0 : 32,
    minWidth: width < 600 ? width * 0.8 : 120,
    minHeight: width < 600 ? 50 : 44,
    justifyContent: 'center',
    alignItems: 'center',
  },

  text_SELECT_EMPLOYEE_RESET: {
    fontSize: 16,
    alignSelf: 'center',
  },

  container_EMPLOYEES_HOME: {
    backgroundColor: colors.buttons,
    width: (Platform.OS === 'web' && width > 992) ? (pagination) ? width / 9 : width / 5 : width * 0.30,
    margin: 10,
    borderRadius: 20,
    flexDirection: Platform.OS !== 'web' ? 'column' : 'row',
    paddingTop: '0.5%',
    paddingBottom: '0.5%',
    alignSelf: 'center',
    alignItems: 'center',
    verticalAlign: 'middle',
    justifyContent: 'center',
  },

  text_EMPLOYEES_HOME: {
    flex: 3,
    textAlign: 'left',
    padding: '5%',
    flexWrap: (Platform.OS === 'web' && width > 1300) ? 'nowrap' : 'wrap',
    verticalAlign: 'middle',
    fontSize: (Platform.OS === 'web' && width > 1300) ? 14 : 12,
    color: colors.text_primary,
  },

  icon_EMPLOYEES_HOME: {
    alignSelf: 'center',
    verticalAlign: 'middle',
    color: colors.text_primary,
  },

  container_EMPLOYEES_HOME_SELECTED: {
    backgroundColor: colors.buttons,
    width: (Platform.OS === 'web' && width > 992) ? (pagination) ? width / 9 : width / 5 : width * 0.30,
    margin: 10,
    flexDirection: Platform.OS !== 'web' ? 'column' : 'row',
    borderRadius: 20,
    borderWidth: 1,
    borderColor: colors.buttons_primary,
    paddingTop: Platform.OS !== 'web' ? '5%' : '0',
    paddingBottom: '0.5%',
    alignSelf: 'center',
    alignItems: 'center',
    verticalAlign: 'middle',
    justifyContent: 'center',
  },

  text_EMPLOYEES_HOME_SELECTED: {
    flex: 3,
    textAlign: 'left',
    verticalAlign: 'middle',
    flexWrap: (Platform.OS === 'web' && width > 1300) ? 'nowrap' : 'wrap',
    padding: '6%',
    fontSize: (Platform.OS === 'web' && width > 1300) ? 16 : 14,
    color: colors.text_primary,
  },

  icon_EMPLOYEES_HOME_SELECTED: {
    alignSelf: 'center',
    verticalAlign: 'middle',
    color: colors.text_primary,
  },

  verticalLineSeparator: {
    backgroundColor: colors.buttons_primary_disabled,
    height: 25,
    width: 2,
    marginHorizontal: 10,
    alignSelf: 'center',
    alignItems: 'center',
    verticalAlign: 'middle',
    justifyContent: 'center',
  },

  icon_after_text_container: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },

  container_COMPANY_FUNCTIONS_CANCEL: {
    width: Platform.OS === 'web' && width > 1300 ? width * 0.10 : width * 0.05,
    height: Platform.OS === 'web' && width > 1300 ? width * 0.03 : '100%',
    flexDirection: 'row',
    margin: 10,
    alignSelf: 'flex-end',
    backgroundColor: colors.background_rejected,
    justifyContent: 'center'
  },


  text_COMPANY_FUNCTIONS_CANCEL: {
    fontSize: 14,
    alignSelf: 'center',
    textAlign: 'center'
  },


  container_MASS_UPLOAD_APPLY: {
    width: Platform.OS === 'web' ? 200 : 150,
    backgroundColor: colors.background_approved,
    alignItems: 'center',
  },

  text_MASS_UPLOAD_APPLY: {
    fontSize: 16,
    alignSelf: 'center',
  },

  container_MASS_UPLOAD_DOWNLOAD: {
    width: Platform.OS === 'web' ? 200 : 150,
    backgroundColor: colors.background_approved,
    alignItems: 'center',
    marginRight: '5%'
  },

  text_MASS_UPLOAD_DOWNLOAD: {
    fontSize: 16,
    alignSelf: 'center',
  },


  container_MASS_UPLOAD_GET_EXCEL: {
    width: '45%',
    backgroundColor: colors.background_rejected,
    alignItems: 'center',
    marginRight: '5%'
  },

  text_MASS_UPLOAD_GET_EXCEL: {
    fontSize: 16,
    alignSelf: 'center',
  },


  container_MASS_UPLOAD_UPLOAD_DATA: {
    width: '45%',
    backgroundColor: colors.background_approved,
    alignItems: 'center',
    marginRight: '5%'
  },

  text_MASS_UPLOAD_UPLOAD_DATA: {
    fontSize: 16,
    alignSelf: 'center',
  },

  container_MASS_UPLOAD_ADD_DATA: {
    width: '20%',
    backgroundColor: 'transparent',
    alignItems: 'center',
  },

  text_MASS_UPLOAD_ADD_DATA: {
    fontSize: 16,
    alignSelf: 'center',
  },

  container_MASS_UPLOAD_DELETE_DATA: {
    width: '20%',
    backgroundColor: 'transparent',
    alignItems: 'center',
  },

  text_MASS_UPLOAD_DELETE_DATA: {
    fontSize: 16,
    alignSelf: 'center',
  },

  container_MASS_UPLOAD_UPLOAD_EXCEL: {
    width: Platform.OS === 'web' ? 200 : 150,
    backgroundColor: colors.background_approved,
    alignItems: 'center',
  },

  text_MASS_UPLOAD_UPLOAD_EXCEL: {
    fontSize: 16,
    alignSelf: 'center',
  },

  container_EDIT_EMPLOYEE_EXPANDABLE: {
    margin: 10,
    width: '100%',
    backgroundColor: 'transparent',
    borderBottomWidth: 0,
    borderBottomColor: colors.buttons_primary,
    alignItems: 'flex-start',
    paddingTop: '1%',
    paddingBottom: '1%',
  },

  text_EDIT_EMPLOYEE_EXPANDABLE: {
    fontSize: 16,
    textAlign: 'left',
    flex: 1,
  },

  icon_EDIT_EMPLOYEE_EXPANDABLE: {
    alignSelf: 'center',
    verticalAlign: 'middle',
    color: colors.text_primary,
  },


  container_EDIT_EMPLOYEE: {
    backgroundColor: 'transparent',
    paddingRight: 0,
    paddingLeft: 0,
    paddingTop: 0,
    paddingBottom: 0,
    // marginRight: '10%',
    alignSelf: 'flex-end',
    flex: 1
  },

  text_EDIT_EMPLOYEE: {
  },

  container_EDIT_EMPLOYEE_REV_ALLOWANCE: {
    backgroundColor: colors.buttons,
    // margin: 10,
    borderRadius: 20,
    borderWidth: 1,
    borderColor: colors.buttons_primary,
  },
  text_EDIT_EMPLOYEE_REV_ALLOWANCE: {
    textAlign: 'left',
    padding: 5,
    fontSize: (Platform.OS === 'web' && width > 1300) ? 16 : 14,
    color: colors.text_primary,
  },
  icon_EDIT_EMPLOYEE_REV_ALLOWANCE: {
    alignSelf: 'center',
    color: colors.text_primary,
  },
  container_EDIT_EMPLOYEE_FIND: {
    flex: 1,
    backgroundColor: colors.background_approved,
    alignItems: 'center',
  },

  text_EDIT_EMPLOYEE_FIND: {
    fontSize: 16,
    alignSelf: 'center',
  },
  container_USER_ROLES_ISSUE_PASSWORD: {
    width: '45%',
    backgroundColor: colors.buttons_primary,
    alignItems: 'center',
    marginRight: '1%'
  },

  text_USER_ROLES_ISSUE_PASSWORD: {
    fontSize: 16,
    alignSelf: 'center',
  },
  container_USER_ROLES_ISSUE_SAVE: {
    width: '45%',
    backgroundColor: colors.background_approved,
    alignItems: 'center',
    marginRight: '1%'
  },
  text_USER_ROLES_ISSUE_SAVE: {
    fontSize: 16,
    alignSelf: 'center',
  },
  container_USER_ROLES_SEND_USERNAME: {
    width: '45%',
    backgroundColor: colors.background_gray,
    alignItems: 'center',
    marginRight: '1%'
  },
  text_USER_ROLES_SEND_USERNAME: {
    fontSize: 16,
    alignSelf: 'center',
  },

  container_EMPL_AUTH_TAB: {
    width: '100%',
    backgroundColor: colors.background_gray,
    alignItems: 'center',
  },
  text_EMPL_AUTH_TAB: {
    fontSize: 16,
    alignSelf: 'center',
  },
  container_EMPL_AUTH_TRASH: {
    backgroundColor: 'transparent',
    paddingRight: 0,
    paddingLeft: 0,
    paddingTop: 0,
    paddingBottom: 0,
    marginLeft: '2%',
    alignSelf: 'center',
  },

  text_EMPL_AUTH_TRASH: {
  },

  icon_EMPL_AUTH_TRASH: {
    color: colors.text_primary,
    alignItems: 'center',
  },
  container_COMP_AUTH_SAVE: {
    width: '45%',
    backgroundColor: colors.background_approved,
  },
  text_COMP_AUTH_SAVE: {
    fontSize: 16,
    alignSelf: 'center',
  },
  container_MAINLEFT: {
    backgroundColor: 'transparent',
    flex: 1,
    padding: 10,
    marginLeft: 20,
    alignSelf: 'flex-start'
  },

  text_MAINLEFT: {
  },

  icon_MAINLEFT: {
    color: colors.text_primary,
    alignItems: 'center',
  },

  container_DISABLED: {
    backgroundColor: 'transparent',
    flex: 1,
    padding: 10,
    marginLeft: 20,
    alignSelf: 'flex-start'
  },

  text_DISABLED: {
  },

  icon_DISABLED: {
    color: colors.buttons_primary_disabled,
    alignItems: 'center',
  },

  container_REPORT: {
    backgroundColor: 'transparent',
    marginHorizontal: 20,
    padding: 3,
    alignSelf: 'flex-start'
  },

  text_REPORT: {
    fontSize: 16,
  },

  icon_REPORT: {
    color: colors.text_primary,
    alignItems: 'center',
  },

});

export default CustomButton;